module.exports = __webpack_public_path__ + "img/img3.f24f190.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img3.png
// module id = 227
// module chunks = 0